import React, { useEffect } from 'react';

import { Form, Input, Button, Image, Alert } from 'antd';
import styles from './login.module.sass';
import { useDispatch, useSelector } from 'react-redux';
import { impersonate } from '../../../../redux/actions/auth';
import VersionCheck from '../../../../shared-components/VersionCheck';
import { STATUS } from '../../../../redux/constants';
import { changeTitle } from '../../../../redux/actions/app';

export default function ImpersonateUser() {
  const loginError = useSelector((state) => state.auth.error);
  const dispatch = useDispatch();

  const handleImpersonate = (data) => {
    dispatch(impersonate(data));
  };

  useEffect(() => {
    document.title = 'Impersonation - Silent Push';
    dispatch(changeTitle('Impersonation'));
  }, []);

  return (
    <div className={styles['login-page']}>
      <div className={styles['login-container']}>
        <>
          <div className={styles['login-form']}>
            <h2 className={styles['login-form-title']}>Impersonate a user</h2>
            <div style={{ marginBottom: 16 }}>
              <span className={styles['login-explanation']}>
                <p>
                  After you start the session,{' '}
                  <b>
                    you'll be logged in as the user you provide in the text
                    field
                  </b>
                </p>
                <Alert
                  message="DO NOT forget to logoff after finishing impersonation session."
                  type="warning"
                />
              </span>
              {loginError && (
                <span className={styles['login-error']}>
                  Incorrect user impersonated email.
                </span>
              )}
            </div>
            <Form onFinish={handleImpersonate} layout={'vertical'}>
              <Form.Item
                label="Impersonate User"
                name="impersonate_user"
                rules={[
                  {
                    type: 'email',
                    message: 'Please input a valid email!',
                  },
                ]}
              >
                <Input
                  placeholder={'Enter the impersonated user email address'}
                />
              </Form.Item>
              <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
                <Button type="primary" htmlType="submit">
                  Impersonate
                </Button>
              </Form.Item>
            </Form>
          </div>
        </>
      </div>
      <VersionCheck parentComponentStatus={STATUS.LOADED} />
    </div>
  );
}
